import type { DirectiveChipProps } from '@assistant-ui/react-lexical'
import { unstable_defaultDirectiveFormatter } from '@assistant-ui/react'
import { DirectiveChip } from '@/components/assistant-ui/directive-text'
import { createDirectiveText } from '@/components/assistant-ui/directive-text.aui'
import {
  CircleHelpIcon,
  FileTextIcon,
  FolderOpenIcon,
  PackageIcon,
  PlusIcon,
  SparklesIcon,
  WrenchIcon,
} from 'lucide-react'

export const dmpChatTriggerIconMap = {
  file: FileTextIcon,
  files: FolderOpenIcon,
  help: CircleHelpIcon,
  new: PlusIcon,
  skill: SparklesIcon,
  tool: WrenchIcon,
  tools: WrenchIcon,
  toolset: PackageIcon,
}

export const dmpChatTriggerFallbackIcon = SparklesIcon

export const DmpChatDirectiveText = createDirectiveText(unstable_defaultDirectiveFormatter, {
  fallbackIcon: dmpChatTriggerFallbackIcon,
  iconMap: dmpChatTriggerIconMap,
})

export function DmpChatDirectiveChip({ directiveId, directiveType, label }: DirectiveChipProps) {
  const Icon = dmpChatTriggerIconMap[directiveType as keyof typeof dmpChatTriggerIconMap] ?? dmpChatTriggerFallbackIcon

  return <DirectiveChip directiveId={directiveId} directiveType={directiveType} Icon={Icon} label={label} />
}

export function hasDmpChatDirective(text: string): boolean {
  return unstable_defaultDirectiveFormatter.parse(text).some((segment) => segment.kind === 'mention')
}
